module.exports = __webpack_public_path__ + "static/media/designP.a35d0c8c.jpg";